import axios from 'axios';
import { ESB_SERVER_URL } from '../constants/Common';

//import {getUserDetails} from '../actions/Auth';
//let tkn = getUserDetails().TOKEN;

//message/sync

export default axios.create({

  baseURL: `http://${ESB_SERVER_URL}:8081/api/`,
  headers: {
    'Content-Type': 'application/json',
    'Accept':'application/json',
    'sender':'FVS',
    'consumer':'CBS',
    'payload_type':'JSON'
  }
});

